import { useState } from 'react';
import { RouterLink } from '@redux-first-router-link';

import { ROUTE_DEPRECATED_IMPORT_PORTFOLIO } from '@/constants/routes';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

import { Button } from '@simplywallst/ui-core';

import { LegacyPortfolioModal } from './LegacyPortfolioModal';

export const LegacyPortfolio = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div
        data-testid="portfolio-legacy-creation"
        className="justify-items-start lg:justify-items-end"
      >
        <p className="mb-0 text-pretty text-xs text-softer">
          Prefer the legacy transaction portfolio?
        </p>
        {isMobileScreen && RUNTIME_ENV === 'native' ? (
          <div className="mt-x1">
            <Button styleType="gentle" onClick={() => setModalOpen(true)}>
              Legacy Portfolio
            </Button>
          </div>
        ) : (
          <RouterLink
            to={{ type: ROUTE_DEPRECATED_IMPORT_PORTFOLIO }}
            noUnderline
          >
            <span className="text-xs text-solid underline">
              Create a legacy portfolio
            </span>
          </RouterLink>
        )}
      </div>
      {isModalOpen && (
        <LegacyPortfolioModal onClose={() => setModalOpen(false)} />
      )}
    </>
  );
};
